import VueI18n from 'vue-i18n'
import Vue from 'vue'
import en from '../../translations/en.json'

Vue.use(VueI18n)
export const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en',
    formatFallbackMessages: false,
    silentTranslationWarn: true, // todo before launch set to false and test if all translations exist
    messages: { en }// set locale messages
})

const loadedLanguages = ['en'];

function setI18nLanguage (lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export function changeLanguage(lang) {
    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language hasn't been loaded yet
    return import( "../../translations/"+lang+".json").then(
        messages => {
            i18n.setLocaleMessage(lang, messages.default)
            loadedLanguages.push(lang)
            return setI18nLanguage(lang)
        }
    )
}
